import { useBreadcrumbs } from "@/composables";
import { type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";

export const setBreadcrumbs = async (route: RouteLocationNormalized, _: RouteLocationNormalized, next: NavigationGuardNext) => {
  const breadcrumbs = useBreadcrumbs();
  const routeBreadcrumbs = route.meta.breadcrumbs ?? [];
  breadcrumbs.set(routeBreadcrumbs);
  return next();
};
